import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { FuseConfigService } from '@fuse/services/config.service';
import { isNumber } from 'lodash';
import { environment } from 'projects/cutting-app/src/environments/environment';

import { LocalStorageManager } from '../helper/local-storage-manager.helper';
import { LogoutService } from '../services/logout.service';

@Injectable()
export class NotAuthAndCheckUserIdGuard {
  constructor(
    private router: Router,
    private fuseConfigService: FuseConfigService,
    private logoutService: LogoutService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const userIdLS = LocalStorageManager.regData;
    let userIdFromRoute: number = route.queryParams.user;
    userIdFromRoute = userIdFromRoute && isNumber(+userIdFromRoute) ? +userIdFromRoute : undefined;
    const authorized = this.authorized();

    if ((!userIdLS || !userIdFromRoute) && authorized) {
      this.logoutService.logout();
    }

    if (!userIdFromRoute) {
      if (!environment.production) {
        const user = prompt('Enter admin user ID');
        this.router.navigate(['/client/auth/login'], { queryParams: { user } });
        return true;
      } else {
        alert($localize`Ошибка загрузки страницы. Обратитесь к администратору.`);
        return false;
      }
    }

    if (!authorized || (authorized && !userIdLS)) {
      LocalStorageManager.regData = userIdFromRoute;
      return true;
    }

    if (userIdLS === userIdFromRoute) {
      this.router.navigate(['/']);
      return true;
    } else {
      this.logoutService.logout();
      LocalStorageManager.regData = userIdFromRoute;
      this.router.navigate(['/client/auth/login'], { queryParams: { user: userIdFromRoute } });

      this.fuseConfigService.config = {
        layout: {
          navbar: {
            hidden: true,
          },
          toolbar: {
            hidden: true,
          },
          footer: {
            hidden: true,
          },
          sidepanel: {
            hidden: true,
          },
        },
      };

      return true;
    }
  }

  authorized(): boolean {
    const LSC = LocalStorageManager.client;

    if (LSC) {
      return LSC.token.refresh !== '';
    }

    return false;
  }
}
